import { expandAccordion, collapseAccordion } from '3-components/Accordion/AccordionHelpers';

interface MobileNavProps {
    el: HTMLDivElement;
    props: {
        collapseOthers?: boolean;
        itemClass?: string;
        triggerClass?: string;
        collapsibleClass?:string;
    };
}

const ITEM_CLASS = 'mobile-nav-item';
const TRIGGER_CLASS = 'mobile-nav-item-btn';
const COLLAPSIBLE_CLASS = 'sub-nav';

const MobileNav = ({ el, props }: MobileNavProps) => {
    const {
        collapseOthers = true,
        itemClass = ITEM_CLASS,
        triggerClass = TRIGGER_CLASS,
        collapsibleClass = COLLAPSIBLE_CLASS
    } = props;

    const itemEls = el.querySelectorAll(`.${itemClass}`);

    const collapseOtherItems = (currentItem: HTMLDivElement) => {
        itemEls.forEach(itemEl => {
            if (itemEl === currentItem || !itemEl.classList.contains('is-open')) return;

            const triggerEl: HTMLButtonElement | null = itemEl.querySelector(`.${triggerClass}`);
            const collapsibleEl: HTMLDivElement | null = itemEl.querySelector(`.${collapsibleClass}`);

            if (!triggerEl || !collapsibleEl) return;

            collapseAccordion(collapsibleEl, () => {
                itemEl.classList.remove('is-open');
                triggerEl.classList.remove('disabled');
                triggerEl.setAttribute('aria-expanded', 'false');
            });
        });
    };

    // Add accordion functionality
    itemEls.forEach(itemEl => {
        const triggerEl: HTMLButtonElement | null = itemEl.querySelector(`.${triggerClass}`);
        const collapsibleEl: HTMLDivElement | null = itemEl.querySelector(`.${collapsibleClass}`);

        if (!triggerEl || !collapsibleEl) return;

        // set default as close if no is-open class
        if (!itemEl.classList.contains('is-open')) {
            collapsibleEl.style.height = '0px';
            triggerEl.setAttribute('aria-expanded', 'false');
        }

        triggerEl.addEventListener('click', () => {
            if (triggerEl.classList.contains('disabled')) {
                return;
            }

            if (itemEl.classList.contains('is-open')) {
                collapseAccordion(collapsibleEl, () => {
                    itemEl.classList.remove('is-open');
                    triggerEl.classList.remove('disabled');
                    triggerEl.setAttribute('aria-expanded', 'false');
                });
            } else {
                expandAccordion(collapsibleEl, () => {
                    itemEl.classList.add('is-open');
                    triggerEl.classList.remove('disabled');
                    triggerEl.setAttribute('aria-expanded', 'true');
                });

                if (collapseOthers) collapseOtherItems(itemEl as HTMLDivElement);
            }
        });
    });
};

export default MobileNav;
